export enum FeatureFlagTypes {
  CanExportTimeslotsToCsv = "canExportTimeslotsToCsv",
  CanExportToSDWorx = "canExportToSDWorx",
  LeaveEntitlements = "leaveEntitlements",
  HrModule = "hrModule",
  ShowLeaveCounters = "showLeaveCounters",
  ShowAvailabilityTypes = "showAvailabilityTypes",
}

export interface ISupportSettingsPracticeData {
  practice: string
}

export interface ISupportSettingsFeaturesData {
  features: FeatureFlagTypes[]
}
